export const pageArray = (number) => {
	return [...Array(number + 1).keys()].slice(1);
	// this is a helper function for the Pagination Station
	// it creates an array of the total number of pages, so that we can map over it to display the pagination buttons.
};

export const truncatePages = (current, last, delta) => {
	let left = current - delta,
		right = current + delta + 1,
		range = [],
		rangeWithDots = [],
		l;

	for (let i = 1; i <= last; i++) {
		if (i == 1 || i == last || (i >= left && i < right)) {
			range.push(i);
		}
	}

	for (let i of range) {
		if (l) {
			if (i - l === 2) {
				rangeWithDots.push(l + 1);
			} else if (i - l !== 1) {
				rangeWithDots.push("...");
			}
		}
		rangeWithDots.push(i);
		l = i;
	}
	return rangeWithDots;
};